import { 
  SET_USERNAME,
  SET_PASSWORD,
  SET_LOGIN_ERROR,
  LOGIN_USER_START,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAIL,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CLOSE_CHANGE_PASSWORD,
  LOGOUT_USER,
  SESSION_EXPIRED,
  SAVE_VIEW,
} from '../actions/types';

const INITIAL_STATE = { 
  username: '',
  password: '',
  changePassword: false,
  isLoggedIn: false,
  loading: false,
  loginError: '',
  user: {},
  token: '',
  autoLogin: false
};

// eslint-disable-next-line 
export default ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
    case SET_USERNAME:
      return { 
        ...state, 
        username: action.payload,
        loginError: ''
      }
    case SET_PASSWORD:
      return { 
        ...state, 
        password: action.payload,
        loginError: ''
      }
    case SET_LOGIN_ERROR:
      return { 
        ...state, 
        loginError: action.payload
      }
    case LOGIN_USER_START:
      return { 
        ...state, 
        loading: true, 
        loginError: '' 
      }
    case LOGIN_USER_SUCCESS:
      return {  
        ...state, 
        isLoggedIn: true,
        user: action.user,
        username: action.user.sName,
        password: action.user.sPassword,
        token: action.token,
        loginError: '',
        autoLogin: action.autoLogin
      }
    case LOGIN_USER_FAIL:
      return { 
        ...state, 
        isLoggedIn: false,
        token: '',
        loading: false,
        loginError: 'Authentication Failed.'
      }
    case CHANGE_PASSWORD:
      return { 
        ...state, 
        loading: false, 
        loginError: 'You have logged in using a temporary password. Please change your password first.',
        changePassword: true,
        user: action.user,
      }
    case CHANGE_PASSWORD_SUCCESS:
      return { 
        ...state, 
        loginError: 'Password changed successfully. Please login using the new password.',
        changePassword: false,
        user: {},
      }
    case CHANGE_PASSWORD_FAIL:
      return { 
        ...state,
        loginError: action.loginError,
      }
    case CLOSE_CHANGE_PASSWORD:
      return { 
        ...state,
        loginError: '',
        changePassword: false,
        user: {},
      }
    case LOGOUT_USER:
      return {
        ...state,
        username: '',
        password: '',
        loading: false,
        loginError: '',
        user: {},
        token: '',
        isLoggedIn: false
      }
    case SESSION_EXPIRED:
      return {
        ...state,
        username: '',
        password: '',
        loading: false,
        user: {},
        token: '',
        isLoggedIn: false,
        loginError: 'Session expired. Please log in again.',
      }      
    case SAVE_VIEW:
      return {  
        ...state, 
        user: action.edit ? state.user : action.user,
      }
    default:
      return state;
  };
};